export const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

export const times = [
    '9am',
    '10:30am',
    '12pm',
    '2pm',
    '3:30pm',
    '5pm',
    '6:30pm',
];
